// Fase H3.2, sección 16 del pedido — formateadores "seguros" para el
// Dashboard Histórico. A diferencia de formatMoneda/formatPorcentaje
// (utils/format.js), que convierten null/undefined/NaN a 0 a propósito
// (correcto para la vista de UN mes en vivo, donde "sin capturar todavía"
// SÍ es $0 real), aquí null/undefined/NaN/Infinity/-Infinity representan
// "no calculable" (ver porcentajeSeguro en backend/utils/pnlHistorico.js) y
// deben mostrarse como "—", NUNCA como $0 ni 0% fabricado.
import { formatMoneda, formatPorcentaje } from './format';

function esNumeroValido(valor) {
  if (valor === null || valor === undefined) return false;
  const n = Number(valor);
  return Number.isFinite(n);
}

export function dineroSeguro(valor) {
  if (!esNumeroValido(valor)) return '—';
  return formatMoneda(Number(valor));
}

export function pctSeguro(valor, decimales) {
  if (!esNumeroValido(valor)) return '—';
  return formatPorcentaje(Number(valor), decimales);
}
